import { useLocation, useNavigate } from 'react-router-dom';
import { styled } from 'styled-components';
import { CaseInfo } from '../../detail/data';
import { useEffect, useState } from 'react';
import { useModal } from '../../../context/ModalContext';
import { isLogin } from '../../../utils/auth';
import SearchService from '../../../service/search/Search';
import InterestSerivce from '../../../service/Interest';
import AddInterestItemModal from '../modal/AddInterestItem';
import Menu from '../menu/Menu';
import { useReportContext } from '../../../context/DetailContext';
import PageModal from '../modal/PageModal';
import QuickSearch from '../../quickSearch/QuickSearch';
import { handleShareDetailPage } from '../../../utils/url';

interface Props {
  caseInfo: CaseInfo | null;
  isScrolledPastSummary: boolean;
  isLikeItem: boolean;
  setIsLikeItem: (isLikeItem: boolean) => void;
  checkIsLikeItem?: (iidx: number) => void;
}

function DetailPageTop({
  caseInfo,
  isScrolledPastSummary,
  isLikeItem,
  setIsLikeItem,
  checkIsLikeItem,
}: Props) {
  const { type, iidx, lat, lng } = useReportContext();
  const navigate = useNavigate();
  const { modalDispatch } = useModal();

  const [openMenu, setOpenMenu] = useState(false);
  const [openSearch, setOpenSearch] = useState(false);
  const [searchInputOpen, setSearchInputOpen] = useState(false);
  const [showLikeModal, setShowLikeModal] = useState(false);
  const [mode, setMode] = useState<string>('add');
  const [selectedItem, setSelectedItem] = useState({
    iidx: 0,
    group: '',
    group_idx: 0,
    level: 0,
    memo: '',
  });
  const [activeItem, setActiveItem] = useState<number | null>(null);

  const disLike = async (iidx: number) => {
    try {
      await InterestSerivce.dislike(iidx);
      alert('관심물건에서 삭제되었습니다.');
      setIsLikeItem(false);
    } catch (error) {
      console.error('dislike 함수에서 에러 발생:', error);
    }
  };

  const handleDisLikeItem = (iidx: number) => {
    if (window.confirm('관심물건에서 삭제하시겠습니까?')) {
      disLike(iidx);
    }
  };

  const handleMapButton = () => {
    const payload = {
      type: type,
      iidx: iidx,
      item_code: '',
      lat: lat,
      lng: lng,
      status: caseInfo?.bid?.trim() === '매각' ? 'B' : 'A',
    };

    const open = encodeURIComponent(JSON.stringify(payload));
    const url = `/map?lat=${lat}&lng=${lng}&open=${open}`;
    window.open(url, '_blank');
  };
  return (
    <Container>
      <Icon
        onClick={() => {
          window.close();
        }}
      >
        <img src="/assets/images/close/close-black-24.svg" alt="" />
      </Icon>
      <Title>
        {caseInfo && (
          <>
            {caseInfo?.caseno}
            {caseInfo?.type === 'p'
              ? '-' + caseInfo?.itemno
              : caseInfo?.itemno.replace(/[^0-9]/g, '')
                ? ' (' + caseInfo?.itemno.replace(/[^0-9]/g, '') + ')'
                : ' (1)'}
          </>
        )}
      </Title>
      {caseInfo && (
        <MapButton onClick={handleMapButton}>지도에서 보기 {'>'}</MapButton>
      )}
      {/* <Icon onClick={() => navigate('/')}>
        <img src="/assets/images/icon/home-black.svg" alt="" />
      </Icon> */}
      {/* {isScrolledPastSummary ? (
        <Icon
          onClick={(e) => {
            e.stopPropagation();
            if (!isLogin()) {
              modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
              return;
            }

            if (!caseInfo) return;

            if (!isLikeItem) {
              setShowLikeModal(true);
            } else {
              handleDisLikeItem(caseInfo.iidx);
            }
          }}
        >
          <img
            src={`/assets/images/icon/${isLikeItem ? 'like-on' : 'like-off-dark'}.svg`}
            alt=""
          />
        </Icon>
      ) : (
        <Icon onClick={() => setOpenSearch(true)}>
          <img src="/assets/images/icon/search-black.svg" alt="" />
        </Icon>
      )} */}
      {/* {isScrolledPastSummary && caseInfo ? (
        <Icon onClick={() => handleShareDetailPage(caseInfo)}>
          <img src="/assets/images/icon/share-dark.svg" alt="" />
        </Icon>
      ) : (
        <Icon
          onClick={() => {
            setOpenMenu(true);
          }}
        >
          <img src="/assets/images/icon/menu-black.svg" alt="" />
        </Icon>
      )} */}

      {showLikeModal && caseInfo && (
        <AddInterestItemModal
          setShowLikeModal={setShowLikeModal}
          selectedIdx={caseInfo.iidx}
          mode={mode}
          selectedItem={selectedItem}
          setActiveItem={setActiveItem}
          checkIsLikeItem={checkIsLikeItem}
        />
      )}

      {openMenu && (
        <PageModal open={openMenu} onClose={() => setOpenMenu(false)}>
          <Menu isModal onClose={() => setOpenMenu(false)} />
        </PageModal>
      )}

      {openSearch && (
        <PageModal open={openSearch} onClose={() => setOpenSearch(false)}>
          <QuickSearch isModal onClose={() => setOpenSearch(false)} />
        </PageModal>
      )}
    </Container>
  );
}

export default DetailPageTop;

const Container = styled.div`
  width: 100%;
  height: 56px;
  padding: 6px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 2px;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1000;
  max-width: inherit;
  border-bottom: 1px solid #e5e8ea;
`;

const Icon = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: none;
  background-color: transparent;
`;

const Title = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;

  font-size: 16px;
  font-weight: 700;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
`;

const MapButton = styled.div`
  color: #008aff;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  padding-right: 10px;
`;
